import httpClient from './httpClient';

export default {
  getIntegrationEmailSettings: integrationId =>
    httpClient.get(`api/business/integration/${integrationId}/lead-email-settings`, { cache: false }),
  setIntegrationEmailSettings: (integrationId, payload) =>
    httpClient.post(`api/business/integration/${integrationId}/lead-email-settings`, payload),
};
